import { AccountSettingsLayout } from '@shared-components/modules';
import React  from 'react';
import { Route } from 'react-router-dom';
import ChangePasswordSettings from './change-password';

const UserAccountSettings: React.FC = () => {
  return (
    <div className="content_margin--fluid">
      <AccountSettingsLayout>
        <Route
          exact
          path="/dashboard/account-settings"
          component={ChangePasswordSettings}
        />
      </AccountSettingsLayout>
    </div>
  );
};

export default UserAccountSettings;
